import {Component} from 'panel';

import {registerMPElement} from '../../util/register-element';
import {eventWasOutside} from '../../util/dom';

import template from './index.jade';

import css from './index.styl?inline';

export const THEME = {
  DARK: `dark`,
  LIGHT: `light`,
  INVALID: `invalid`,
};

export const SIZE = {
  SMALL: `small`,
  DEFAULT: `default`,
};

export default registerMPElement(
  `mp-tag`,
  class extends Component {
    static get attrsSchema() {
      return {
        ...super.attrsSchema,
        clickable: `boolean`,
        icon: `string`,
        removable: `boolean`,
        size: {type: `string`, default: SIZE.DEFAULT, enum: Object.values(SIZE)},
        'tag-name': `string`,
        theme: {type: `string`, default: THEME.LIGHT, enum: Object.values(THEME)},
      };
    }

    get config() {
      return {
        useShadowDom: true,
        css,
        template,
        helpers: {
          THEME,
          SIZE,
          remove: (ev) => {
            ev.stopPropagation();
            this.dispatchEvent(new CustomEvent(`remove`, {detail: {tagName: this.attr(`tag-name`)}}));
          },
          select: (ev) => {
            const removeTag = this.el.querySelector(`.remove-tag`);
            if (!removeTag || eventWasOutside(ev, removeTag)) {
              this.dispatchEvent(new CustomEvent(`select`, {detail: {tagName: this.attr(`tag-name`)}}));
            }
          },
        },
      };
    }
  },
);
